// extracted by mini-css-extract-plugin
export default {"container":"CreatePostForm_container__oGMd8","image_preview":"CreatePostForm_image_preview__5WnyW"};